module.exports = {
  initializeUploadCheckOnce: function () {
    return window.Android;
  },

  initializeUpload: function () {
    var $button = this.$el.find('.uploader.progress-button');

    $button.on('click', _.bind(function (event) {
      var sizeName = 'o';
      this.appBridge.callAndroid('photo_upload', {
        'size_name': sizeName
      });
    }, this));
  }
};
